import './about-us.scss';
import { setupLayout } from '../Shared/layout';
import * as $ from 'jquery';
import 'owl.carousel/dist/owl.carousel';
import { slideDown } from '../../src/module/dom';

setupLayout();

const button = document.getElementById('js-slideDownButton')
button.addEventListener('click', () => {
    slideDown(document.getElementById('js-slideDownElement'));
    button.style.display = 'none';
});

$(document).ready(function () {
    $('.owl-milestone-1').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 6000,
        smartSpeed: 1500,
        responsive: {
            0: {
                items: 2
            },
            426: {
                items: 4
            },
            1025: {
                items: 4
            }
        }
    });
    setTimeout(() => {
        $('.owl-milestone-2').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 1500,
            responsive: {
                0: {
                    items: 2
                },
                426: {
                    items: 4
                },
                1025: {
                    items: 4
                }
            }
        });
    }, 3000);

    $('.owl-pholosophy').owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1
            },
            426: {
                items: 2
            },
            1025: {
                items: 2
            }
        }
    });

    $('.owl-coreValue').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 2
            },
            426: {
                items: 4
            },
            769: {
                items: 5
            },
            1025: {
                items: 5
            },
            1367: {
                items: 6
            }
        }
    });

    $('.owl-CEOCOO').owlCarousel({
        loop: false,
        margin: 32,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1
            },
            426: {
                items: 2
            },
            1025: {
                items: 2
            }
        }
    });
});